import React from 'react';
import { DeliveryMethodSelector, Heading, HeadingEnum, TextColorEnum } from '@desquared/wave-components-library';
import { toNumber } from 'lodash';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import isEmpty from 'lodash/isEmpty';

import { SelectedShopId } from '@/store/isAddressRegistered';
import useDeliveryServices from '@/hooks/useDeliveryServices';
import { Shop } from '@/store/shop';
import { IsFromLoginStore } from '@/store/isFromLogin';

import styles from './SelectServicePage.module.css';

export default function SelectServicePage(props) {
  const t = useTranslations('common.asides.service_address');
  const router = useRouter();

  const {
    options,
    addressPickerStatus,
    setSelectedShop,
    setSelectedService,
    updateSelectedDeliveryService,
    selectedService,
  } = useDeliveryServices();

  const onDeliveryServiceSelection = serviceId => {
    IsFromLoginStore.update(true);
    updateSelectedDeliveryService(serviceId);
    SelectedShopId.update('');
    Shop.setSelectedShop('');
    setSelectedShop('');
    const selectedService = options.find(i => i.id === serviceId);
    setSelectedService(selectedService);
    if (selectedService?.deliversToAddress) {
      if (!isEmpty(props?.user)) {
        router.push('/address-details');
      } else {
        router.push('/guest-add-address');
      }
    } else {
      router.push('/select-store');
    }
  };
  if (!options) return null;

  return (
    <div className={styles.outerContainer}>
      <Heading
        color={TextColorEnum.Gray1}
        type={HeadingEnum.HeadingS}
        classOption={styles.title}
        style={{ fontWeight: 700 }}
      >
        {t('select_header')}
      </Heading>
      <div className={styles.paddingContainer}>
        <DeliveryMethodSelector
          selected={toNumber(addressPickerStatus)}
          options={options}
          onClick={onDeliveryServiceSelection}
        />
      </div>
    </div>
  );
}
